import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { HashRouter, BrowserRouter, Route, Link } from 'react-router-dom';

import { getToken } from 'global/auth';
import $ from 'jquery';

import Home from 'home/Home';


const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            authorization: getToken(),
        },
    };
});

const client = new ApolloClient({
    link: authLink.concat(new HttpLink({ uri: window.apolloServerUrl })),
    cache: new InMemoryCache(),
});
window.apolloClient = client;

let theme = createMuiTheme({
    palette: {
        type: 'light',
        primary: { main: '#0E7490', light: '#22D3EE', dark: '#081C34', contrastText: '#FFFFFF' },
        secondary: { main: '#2563EB', contrastText: '#FFFFFF' },
        background: { default: '#F3F6F9', paper: '#FFFFFF' },
        text: { primary: '#0F172A', secondary: '#64748B' },
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontWeightRegular: 400,
        fontWeightMedium: 600,
    },
    shape: { borderRadius: 12 },
    overrides: {
        MuiButton: { root: { borderRadius: 10, textTransform: 'none', fontWeight: 700, boxShadow: 'none' } },
        MuiPaper: { rounded: { borderRadius: 14 } },
        MuiDialog: { paper: { borderRadius: 18 } },
        MuiTooltip: { tooltip: { borderRadius: 8, fontSize: 12 } },
    },
});
// Il colore configurato dal tenant resta disponibile alle pagine legacy.
// La shell 3.0 usa una palette stabile per uniformare l'esperienza.
theme = { ...theme };
window.theme = theme;

export const appChageTheme = { func: undefined };

export default class App extends Component {
    constructor(props) {
        super(props);
        this.changeTheme = this.changeTheme.bind(this);
        appChageTheme.func = this.changeTheme;


        // $(window).keydown(function (event) {
        //     if (event.keyCode == 13) {
        //         event.preventDefault();
        //         return false;
        //     }
        // });

    }

    componentDidMount() {
        $('html').css('height', '100%');
    }

    state = {
        theme,
    };

    changeTheme(type) {
        const t = createMuiTheme({
            palette: {
                type,
            },
        });

        const t0 = getMuiTheme({
            palette: {
                type,
            },
        });

        this.setState({ theme: t, themeV0: t0 });

    }


    render() {
        return (

            <ApolloProvider client={client}>
                
                <MuiThemeProvider theme={this.state.theme}>
                    <HashRouter key="root-router" >
                        <Route label="Home" path="/" component={Home} />
                    </HashRouter >
                </MuiThemeProvider>
                
            </ApolloProvider>


        );
    }
}

